/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

export class Queue {
  private queue = [];

  constructor(collection?) {
    if (collection) {
      for (const key in collection) {
        if ({}.hasOwnProperty.call(collection, key)) {
          this.enqueue(collection[key]);
        }
      }
    }
  }

  get(index: number) {
    if (this.queue.length > index) {
      return this.queue[index];
    }
  }

  enqueue(obj) {
    this.queue.push(obj);
  }

  dequeue() {
    if (this.canDequeue()) {
      return this.queue.shift();
    }
    return;
  }

  clear() {
    this.queue = [];
  }

  canDequeue() {
    return this.queue.length > 0;
  }

  size() {
    return this.queue.length;
  }
}
